var BillingFrequency;
(function(BillingFrequency) {
    BillingFrequency["MONTHLY"] = "MONTHLY";
    BillingFrequency["QUARTERLY"] = "QUARTERLY";
})(BillingFrequency || (BillingFrequency = {}));
var BundleLineItemProductType;
(function(BundleLineItemProductType) {
    BundleLineItemProductType["LENS"] = "LENS";
    BundleLineItemProductType["SOLUTION"] = "SOLUTION";
})(BundleLineItemProductType || (BundleLineItemProductType = {}));
var BundleLineItemType;
(function(BundleLineItemType) {
    BundleLineItemType["COMPOSITE"] = "COMPOSITE";
    BundleLineItemType["CONTACT_LENSES_BENELUX"] = "CONTACT_LENSES_BENELUX";
    BundleLineItemType["CONTACT_LENSES_SUBSCRIPTION"] = "CONTACT_LENSES_SUBSCRIPTION";
    BundleLineItemType["NON_PRESCRIPTION_BUNDLE"] = "NON_PRESCRIPTION_BUNDLE";
    BundleLineItemType["PRESCRIPTION_GLASSES"] = "PRESCRIPTION_GLASSES";
})(BundleLineItemType || (BundleLineItemType = {}));
var CartCustomerType;
(function(CartCustomerType) {
    CartCustomerType["B2B"] = "B2B";
    CartCustomerType["B2C"] = "B2C";
})(CartCustomerType || (CartCustomerType = {}));
var ChannelType;
(function(ChannelType) {
    ChannelType["ONLINE"] = "ONLINE";
    ChannelType["STORE"] = "STORE";
})(ChannelType || (ChannelType = {}));
var CheckoutState;
(function(CheckoutState) {
    CheckoutState["Finalized"] = "Finalized";
    CheckoutState["InProgress"] = "InProgress";
    CheckoutState["ReadyToOrder"] = "ReadyToOrder";
})(CheckoutState || (CheckoutState = {}));
var DeliveryFrequency;
(function(DeliveryFrequency) {
    DeliveryFrequency["MONTHLY"] = "MONTHLY";
    DeliveryFrequency["QUARTERLY"] = "QUARTERLY";
})(DeliveryFrequency || (DeliveryFrequency = {}));
var DiscountType;
(function(DiscountType) {
    DiscountType["ABSOLUTE"] = "ABSOLUTE";
    DiscountType["CartDiscount"] = "CartDiscount";
    DiscountType["ProductDiscount"] = "ProductDiscount";
    DiscountType["RELATIVE"] = "RELATIVE";
})(DiscountType || (DiscountType = {}));
var DiscountValueType;
(function(DiscountValueType) {
    DiscountValueType["ABSOLUTE"] = "ABSOLUTE";
    DiscountValueType["GIFT"] = "GIFT";
    DiscountValueType["RELATIVE"] = "RELATIVE";
})(DiscountValueType || (DiscountValueType = {}));
var EyeSide;
(function(EyeSide) {
    EyeSide["BOTH"] = "BOTH";
    EyeSide["LEFT"] = "LEFT";
    EyeSide["RIGHT"] = "RIGHT";
})(EyeSide || (EyeSide = {}));
var LineItemType;
(function(LineItemType) {
    LineItemType["BUNDLE"] = "BUNDLE";
    LineItemType["CONTACTLENSES"] = "CONTACTLENSES";
    LineItemType["REGULAR"] = "REGULAR";
})(LineItemType || (LineItemType = {}));
var SanitizationAction;
(function(SanitizationAction) {
    SanitizationAction["KeepExisting"] = "KeepExisting";
    SanitizationAction["Replace"] = "Replace";
})(SanitizationAction || (SanitizationAction = {}));
var ValidationCode;
(function(ValidationCode) {
    ValidationCode["CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES"] = "CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES";
    ValidationCode["HAS_VALID_OPTICIAN_DETAILS"] = "HAS_VALID_OPTICIAN_DETAILS";
    ValidationCode["HAS_VALID_PRESCRIPTION_DATA_RANGES"] = "HAS_VALID_PRESCRIPTION_DATA_RANGES";
    ValidationCode["IS_IN_STOCK"] = "IS_IN_STOCK";
    ValidationCode["IS_VALID_AMOUNT_OF_MASTER_VARIANTS"] = "IS_VALID_AMOUNT_OF_MASTER_VARIANTS";
    ValidationCode["IS_VALID_CART_BY_PRESCRIPTION"] = "IS_VALID_CART_BY_PRESCRIPTION";
    ValidationCode["IS_VALID_EXPIRY_DATE"] = "IS_VALID_EXPIRY_DATE";
    ValidationCode["IS_VALID_QUANTITY"] = "IS_VALID_QUANTITY";
    ValidationCode["MAX_QUANTITY_PER_LINE_ITEM_TYPE"] = "MAX_QUANTITY_PER_LINE_ITEM_TYPE";
    ValidationCode["MAX_QUANTITY_PER_PRODUCT_TYPE"] = "MAX_QUANTITY_PER_PRODUCT_TYPE";
    ValidationCode["MAX_VARIANTS_PER_PRODUCT_TYPE"] = "MAX_VARIANTS_PER_PRODUCT_TYPE";
    ValidationCode["ONE_LENS_TYPE_PER_EYE"] = "ONE_LENS_TYPE_PER_EYE";
    ValidationCode["PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT"] = "PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT";
    ValidationCode["PRODUCTS_ARE_PUBLISHED"] = "PRODUCTS_ARE_PUBLISHED";
    ValidationCode["REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE"] = "REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE";
    ValidationCode["VALID_CART_BY_PRODUCT_TYPES"] = "VALID_CART_BY_PRODUCT_TYPES";
    ValidationCode["VALID_RELATIONS_BUNDLE_PRODUCTS"] = "VALID_RELATIONS_BUNDLE_PRODUCTS";
})(ValidationCode || (ValidationCode = {}));
var VoucherState;
(function(VoucherState) {
    VoucherState["ApplicationStoppedByPreviousDiscount"] = "ApplicationStoppedByPreviousDiscount";
    VoucherState["DoesNotMatchCart"] = "DoesNotMatchCart";
    VoucherState["MatchesCart"] = "MatchesCart";
    VoucherState["MaxApplicationReached"] = "MaxApplicationReached";
    VoucherState["NotActive"] = "NotActive";
    VoucherState["NotValid"] = "NotValid";
})(VoucherState || (VoucherState = {}));

export { BillingFrequency, BundleLineItemProductType, BundleLineItemType, CartCustomerType, ChannelType, CheckoutState, DeliveryFrequency, DiscountType, DiscountValueType, EyeSide, LineItemType, SanitizationAction, ValidationCode, VoucherState };
//# sourceMappingURL=sharedTypes.js.map
